module.exports = __webpack_public_path__ + "static/Tastea1-86b3161e783cb5f6f05fcaabc1c37cf4.jpg";